var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLifestream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.752 71.59-3.244-34.627 20.25 6.995-1.18-12.592 53.258-4.989 4.01 42.813-53.258 4.988-1.18-12.592-18.656 10.005Zm31.6-6.77 30.076-2.817-1.15-12.278-1.15-12.277L45 40.188l1.528 12 .825 12.632Z",
    fill: "#FFC239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m47.353 64.82 30.075-2.817-1.15-12.278c.108 1.154-.396 2.663-3.278 3.462-1.56.434-6-.207-8.5-2.5-2.5-2.292-4.748-5.783-9-5.5-6 .4-7 4.538-8.972 7l.825 12.633Z",
    fill: "#FFC239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.409 61.586 15.752 71.591l-3.244-34.628 20.25 6.995m1.65 17.628-1.65-17.628m1.65 17.628 1.18 12.592 53.258-4.988-4.01-42.813-53.258 4.989 1.18 12.592m13.77 8.23-1.528-12 30.128-2.74 1.15 12.277m-29.75 2.462.825 12.633 30.075-2.817-1.15-12.278m-29.75 2.462c1.972-2.462 2.972-6.6 8.972-7 4.252-.283 6.5 3.208 9 5.5 2.5 2.293 6.94 2.934 8.5 2.5 2.882-.8 3.386-2.307 3.278-3.462",
    stroke: "#0D0D0D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestream);
export default __webpack_public_path__ + "static/media/lifestream.b39be64eda7bfb012739841f5b7c19e6.svg";
export { ForwardRef as ReactComponent };